import { render, staticRenderFns } from "./LivePublishPlanGroup.vue?vue&type=template&id=f5a8f50e&scoped=true"
import script from "./LivePublishPlanGroup.vue?vue&type=script&lang=js"
export * from "./LivePublishPlanGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a8f50e",
  null
  
)

export default component.exports